import { LIBRARY_METADATA_SOURCE_ADD_EXERCISE } from "../utils/exercise-library-metadata";

export { LIBRARY_METADATA_SOURCE_ADD_EXERCISE };

/**
 * End library metadata actions invoked from Add Exercise Save.
 * No flash, no `refreshWith` — exercise/save owns UX (flash + refresh).
 *
 * Returns the saved metadata (200 + JSON) so Add Exercise can apply it to the
 * exercise being added in the same Save (the in-memory library cache is stale until
 * refresh). Rill serializes the `res.body` object to JSON. `video` carries the
 * server-resolved value (incl. the uploaded video URL).
 *
 * @param {object} res — Rill response.
 * @param {object} [savedMetadata] — `otherExerciseProperties` result from the action.
 */
export function respondLibraryMetadataFromAddExercise(res, savedMetadata) {
  res.status = 200;
  res.body = savedMetadata
    ? {
        video: savedMetadata.video ?? "",
        instructions: savedMetadata.instructions ?? "",
        exerciseTypeField: savedMetadata.exerciseTypeField ?? "",
        primaryMuscleGroup: savedMetadata.primaryMuscleGroup ?? "",
        secondaryMuscleGroup: savedMetadata.secondaryMuscleGroup ?? "",
      }
    : {};
}

/**
 * @param {string|undefined} source
 * @returns {boolean}
 */
export function isLibraryMetadataFromAddExercise(source) {
  return source === LIBRARY_METADATA_SOURCE_ADD_EXERCISE;
}
